import { BlocksIconCloseCircle } from 'blocks-nextjs/blocks-web-components/components/icon/icons/close-circle';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCloseCircle = createComponent({ react: React, tagName: 'cat-icon-close-circle', elementClass: BlocksIconCloseCircle });
